/**
 * FavoriteButton
 * 
 * @Author: Focci
 * @Date: 2023-08-19 07:52:24
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-19 07:52:24
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import Favorite from '@comp/page/common/favorite'
import SVGAddlist from '@img/add-list.svg'
import SVGAddlisted from '@img/add-listed.svg'
import { useTranslations } from 'next-intl'

function FavoriteButtonTrigger({ actived }) {
  const tc = useTranslations('common')
  const Icon = actived ? SVGAddlisted : SVGAddlist

  return (
    <div 
      className={clsx([
        'rounded-full flex items-center gap-1 justify-center h-[1.6rem] px-3',
        'bg-primary text-white'
      ])}
    >
      <Icon width=".7rem" />
      {actived ? tc('collectioned') : tc('collection')}
    </div>
  )
}

export default function FavoriteButton({
  houseId,
  house
}) {
  return (
    <Favorite 
      houseId={houseId}
      house={house}
      Trigger={FavoriteButtonTrigger} 
    />
  )
}

FavoriteButton.propTypes = {
  houseId: PropTypes.number,
}
